define.alias("ember-composable-helpers/helpers/noop", "settings/helpers/noop");